'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = require('../PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A light version of the "portals" component concept
 *
 * This doesn't render anything to the DOM directly via render(), but it
 * will create a new render tree in an existing (provided) DOM node.
 */
exports.default = _react2.default.createClass({
  displayName: 'Portal',

  propTypes: {
    /**
     * Children to render into `container`
     */
    children: _PropTypes2.default.node.isRequired,
    /**
     * DOM Node target you want to render into
     */
    container: _PropTypes2.default.DOMElement.isRequired,
    /**
     * Element type to wrap the `children` in (defaults to <div />)
     */
    element: _PropTypes2.default.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      element: _react2.default.DOM.div
    };
  },
  componentDidMount: function componentDidMount() {
    this.renderPortal(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.renderPortal(nextProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    _reactDom2.default.unmountComponentAtNode(this.props.container);
  },
  renderPortal: function renderPortal(props) {
    var container = props.container,
        children = props.children,
        element = props.element;

    _reactDom2.default.render(element(null, children), container);
  },
  render: function render() {
    return null;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/components/Portal.js
// module id = 189
// module chunks = 0